import { render, staticRenderFns } from "./VStats.vue?vue&type=template&id=c088f99e&"
import script from "./VStats.vue?vue&type=script&lang=js&"
export * from "./VStats.vue?vue&type=script&lang=js&"
import style0 from "./VStats.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports